export const config = {
    get procurementEvidenceEnabled() {
        const runtime = window.runtimeConfig?.procurementEvidenceEnabled;
        return runtime === null || runtime === undefined
            ? import.meta.env.VITE_PROCUREMENT_EVIDENCE_ENABLED === 'true'
            : runtime === true || runtime === 'true';
    },
    get bffUrl() {
        return (
            window.runtimeConfig?.bffUrl || import.meta.env.VITE_BFF_URL
        );
    },

    get hankoUrl() {
        return (
            window.runtimeConfig?.hankoUrl || import.meta.env.VITE_HANKO_API_URL
        );
    },

    // auth-service, the OAuth server for MCP connectors (/oauth/login hands it the session). Deployment
    // config only - never taken from a URL parameter, since the session token is posted there.
    get authUrl() {
        return (
            window.runtimeConfig?.authUrl || import.meta.env.VITE_AUTH_URL
        );
    },

    get gtmId() {
        return (
            window.runtimeConfig?.gtmId || import.meta.env.VITE_GTM_ID || 'GTM-PFRX4FT5'
        );
    },

    get companyIdentityEnabled() {
        if (window.runtimeConfig?.companyIdentityEnabled !== null && window.runtimeConfig?.companyIdentityEnabled !== undefined) {
            return window.runtimeConfig.companyIdentityEnabled === true || window.runtimeConfig.companyIdentityEnabled === 'true';
        }
        return import.meta.env.VITE_COMPANY_IDENTITY_ENABLED === 'true';
    },

    get termsUrl() {
        return (
            window.runtimeConfig?.termsUrl || import.meta.env.VITE_TERMS_URL || '/terms-and-conditions'
        );
    },

    get termsUrlFi() {
        return (
            window.runtimeConfig?.termsUrlFi || import.meta.env.VITE_TERMS_URL_FI || `${this.bffUrl}/api/public/legal/terms?lang=fi`
        );
    },

    get termsUrlEn() {
        return (
            window.runtimeConfig?.termsUrlEn || import.meta.env.VITE_TERMS_URL_EN || `${this.bffUrl}/api/public/legal/terms?lang=en`
        );
    },

    get termsUrlSv() {
        return (
            window.runtimeConfig?.termsUrlSv || import.meta.env.VITE_TERMS_URL_SV || `${this.bffUrl}/api/public/legal/terms?lang=sv`
        );
    },
};
